// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import okrEntity from './entities/okr.json';
import okrMenu from '../pages/okr/menu.json';
import okrFullForm from '../pages/okr/forms/full.json';
import okrContextForm from '../pages/okr/forms/context.json';
import okrMiniForm from '../pages/okr/forms/mini.json';
import okrLookupForm from '../pages/okr/forms/lookup.json';
import okrTableView from '../pages/okr/views/table.json';
import okrStagesView from '../pages/okr/views/stages.json';
import okrCardsView from '../pages/okr/views/cards.json';
import okrInlineView from '../pages/okr/views/inline.json';
import okrBacklogView from '../pages/okr/views/backlog.json';
import okrSplitView from '../pages/okr/views/split.json';
import okrCalendarView from '../pages/okr/views/calendar.json';
import okrDashboardView from '../pages/okr/views/dashboard.json';

/** Тип запису «Ціль» зі сторінками пакета: меню, форми та подання з pages/okr/. */
export const okrDefinition: IRecordTypeDefinition = {
  ...okrEntity,
  views: assembleViewSet({
      table: okrTableView,
      stages: okrStagesView,
      cards: okrCardsView,
      inline: okrInlineView,
      backlog: okrBacklogView,
      split: okrSplitView,
      calendar: okrCalendarView,
      dashboard: okrDashboardView,
  }),
  form: okrFullForm,
  forms: { full: okrFullForm, context: okrContextForm, mini: okrMiniForm, lookup: okrLookupForm },
  menu: okrMenu,
} as IRecordTypeDefinition;
